export default class OrganisationModel {
  constructor (data) {
    this.locations = []
    this.logentries = []
    this.location = null

    this.values = {
      id: null,
      image: null,
      name: null,
      location_id: null,
      vat: null,
      coc: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }
  getTitle () {
    return [this.values.name].join(' ')
  }
  getSubtitle () {
    if (this.location) {
      return [ this.location.values.visitcity ].join(' ')
    } else {
      return ''
    }
  }
  getImage () {
    return this.values.image
  }
  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 1).toUpperCase()
    }

    return null
  }
  getCompareString () {
    let title = []    

    if (this.values.name) {
      title.push(this.values.name)
    }

    if (this.location) {
      title.push(this.location.values.visitcity)
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/organisation/model/OrganisationModel.js